import { useState, forwardRef } from "react";
import { Eye, EyeOff } from "lucide-react";

/**
 * Password input with an inline "Show / Hide" toggle.
 * Drop-in replacement for <input type="password" .../> — pass any props you would to <input>.
 */
const PasswordInput = forwardRef(function PasswordInput(
  { className = "", style = {}, "data-testid": testId, ...rest },
  ref,
) {
  const [visible, setVisible] = useState(false);

  return (
    <div className="relative">
      <input
        {...rest}
        ref={ref}
        data-testid={testId}
        type={visible ? "text" : "password"}
        className={`${className} pr-11`}
        style={style}
      />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? "Hide password" : "Show password"}
        aria-pressed={visible}
        data-testid={testId ? `${testId}-toggle` : "password-toggle"}
        className="absolute inset-y-0 right-2 my-auto h-8 w-8 inline-flex items-center justify-center rounded-md text-[11px] font-mono uppercase tracking-wider hover:bg-[color:var(--wofy-surface)] transition-colors"
        style={{ color: "var(--wofy-text-soft)" }}
        tabIndex={-1}
      >
        {visible ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      </button>
    </div>
  );
});

export default PasswordInput;
